import { makeStyledIcon } from './makeStyledIcon';

const RightArrow = (() =>
  makeStyledIcon(({ color, ...restProps }) => (
    <svg
      {...restProps}
      viewBox='0 0 13 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.4624 4.76717L8.57028 0.0985525C8.49527 0.028519 8.40157 -0.00620216 8.30676 0.000911192C8.21195 0.00802455 8.12256 0.056483 8.05539 0.137184C7.98822 0.217884 7.94789 0.325274 7.94197 0.43918C7.93605 0.553086 7.96495 0.66567 8.02324 0.755784L11.2489 4.63119H0.389844C0.286451 4.63119 0.187293 4.68053 0.114183 4.76837C0.0410728 4.85621 0 4.97534 0 5.09956C0 5.22378 0.0410728 5.34291 0.114183 5.43075C0.187293 5.51859 0.286451 5.56793 0.389844 5.56793H11.2426L8.02324 9.43578C7.97958 9.47654 7.94364 9.528 7.91781 9.58672C7.89197 9.64545 7.87682 9.71011 7.87338 9.77641C7.86993 9.84271 7.87826 9.90913 7.89782 9.97126C7.91737 10.0334 7.94771 10.0898 7.9868 10.1368C8.0259 10.1838 8.07286 10.2202 8.12458 10.2437C8.17629 10.2672 8.23158 10.2772 8.28676 10.2731C8.34194 10.2689 8.39576 10.2507 8.44464 10.2197C8.49352 10.1886 8.53635 10.1455 8.57028 10.093L12.4624 5.41684C12.5324 5.32957 12.5714 5.21315 12.5714 5.09201C12.5714 4.97087 12.5324 4.85444 12.4624 4.76717Z'
        fill={color}
      />
    </svg>
  )))();

export default RightArrow;
